/**
 * @author francklin
 * @created 2020.12.07
 * @updated 2022.01.07
 */

import Vue from 'vue'

export default ({store}, options={})=>{
  Vue.use({
    install(Vue){
      class API extends Vue {
        constructor(){
          super()
          this.namespace = '';
          this.apis = options.apis || {};
          this.$store = store;console.log(this.apis);
        }
        importNamespace(apis,namespace){
          if(namespace&&!this.apis[namespace]) this.apis[namespace] = apis;
          return (() => {
            let namespace = namespace;
            let parent = this;
            return {
              namespace,
              apis,
              invoke(apiPathName) {
                let args = [].slice.apply(arguments);
                if(namespace){
                  args[0] = `${namespace}.${apiPathName}`;
                  return parent.invoke.apply(parent, args);
                } else {
                  args[0] = {
                    apiPathName,
                    apis: this.apis
                  }
                  return parent.invoke.apply(parent, args);
                }
              }
            }
          })();
        }
        invoke(vApiPathName,data){
          var args = [].slice.apply(arguments);
          if(_.isString(vApiPathName)){
            var apiPathName = vApiPathName;
            var names = apiPathName.split(".");
            var parentObj = this.apis;
          } else {
            var apiPathName = vApiPathName.apiPathName;
            var names = apiPathName.split(".");
            var parentObj = vApiPathName.apis;
          }

          for(let i=0;i<names.length-1;i++){
            parentObj=parentObj[names[i]];
            if(!parentObj) return Promise.reject(new Error(`API调用错误: ${apiPathName}`));
          }
          return parentObj[names.pop()].apply(this,args.slice(1));
        }
      }
      Vue.prototype.$api = new API();
    }
  });
}
